import { useContext } from 'react';
import { Hide } from '@s20/components/common/Hide';
import { FormContext } from '../../../common/forms/FormElements';
import { getJobId } from '../common';
import { useJobQuery } from './useJobQuery';
import { Job } from './Job';

export const InfoPane = ({ crewEta }) => {
    const { values, setFieldValue } = useContext(FormContext);
    const { selectedJobId, selectedEquipmentId } = values;

    const { data: jobs } = useJobQuery();
    const selectedJob = jobs?.find((job) => selectedJobId === getJobId(job));

    if (!selectedJobId) {
        return null;
    }

    return (
        <>
            <Hide mdUp>
                <div className="ml-2 map-information-pane customer-portal-pane show">
                    <Job
                        selectedEquipmentId={selectedEquipmentId}
                        onClose={() => {
                            setFieldValue('selectedJobId', null);
                            setFieldValue('selectedEquipmentId', null);
                        }}
                        {...selectedJob}
                        crewEta={crewEta}
                    />
                </div>
            </Hide>

            <Hide smDown>
                <Job
                    selectedEquipmentId={selectedEquipmentId}
                    {...selectedJob}
                    crewEta={crewEta}
                />
            </Hide>
        </>
    );
};

